import React, { useState, useEffect, useCallback, useRef } from "react";
import Config from "../../Config.js";
import swal from "sweetalert";
import { CheckEmailSupportenabled } from "../../api/packageApi";
const Contactandhelp = () => {
  const [username, setusername] = useState("");
  const [userEmail, setuserEmail] = useState("");
  const [usercomment, setcomment] = useState("");

  const CreateContactAndHelp = async (e) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (username === "" || username === null || username === undefined) {
      return;
    }
    if (userEmail === "" || userEmail === null || userEmail === undefined) {
      return;
    }
    let ContactHelpModel = {
      UserCompanyID: loginid,
      name: username,
      email: userEmail,
      subject: "Contact and help",
      body: usercomment,
      attachFileList: [],
    };
    let response = await CheckEmailSupportenabled();
    if (response === true || response === "true") {
      fetch(Config.apiUrl + "EmailQueue/Create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(ContactHelpModel),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          if (resp1?.responseType === "Success") {
            setuserEmail("");
            setusername("");
            setcomment("");
            swal("Thank You", "Your message has been sent.", "success");
          } else {
            swal("Sorry", "Pleace  Contact Admin.", "error");
          }
        });
    } else {
      swal(
        "oops!",
        "Sorry! to increase your email support enabled.",
        "warning"
      );
    }
  };

  return (
    <div>
      <div className="container-fluid impression">
        <div>
          <ol className="breadcrumb float-xl-right">
            <li className="breadcrumb-item">
              <a href="/home">Home</a>
            </li>
            <li className="breadcrumb-item active">Contact and help</li>
          </ol>
          <h1 className="page-header">Contact and help</h1>
        </div>
        <div className="liststyletype">
          <p>
            Need help in understating our{" "}
            <span>
              {" "}
              <a href="Lifetags.io">Lifetags.io</a>{" "}
            </span>{" "}
            or facing some problems in using. our system
          </p>
          <p>
            Please send us your message by filling out below contact form, with
            your Name, Email and the message
          </p>
        </div>
        <div className="row mt-3">
          <div className="col-md-5">
            <b>Contact form</b>
            <div className="mt-3 text-center">
              <form
                action="javascript:void(0);"
                onSubmit={(e) => {
                  CreateContactAndHelp(e);
                }}
              >
                <div className="form-group mt-2">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Name"
                    value={username}
                    onChange={(e) => {
                      setusername(e.target.value);
                    }}
                    required
                  />
                </div>
                <div className="form-group mt-2">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Email"
                    required
                    value={userEmail}
                    onChange={(e) => {
                      setuserEmail(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group mt-2">
                  <textarea
                    className="form-control"
                    rows="3"
                    value={usercomment}
                    onChange={(e) => {
                      setcomment(e.target.value);
                    }}
                    placeholder="Message"
                  ></textarea>
                </div>
                {/* <button type="button" onClick={(e) => { CreateContactAndHelp(e) }} className="btn  btn-primary shadow-add">SEND</button> */}
                <button type="submit" className="btn  btn-primary shadow-add">
                  SEND
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contactandhelp;
